export enum CellStatus {
    Closed = 'Closed',
    Open = 'Open',
    Exceptions = 'Exceptions',
}

export enum RestrictionFormStep {
    FormStep = 'formStep',
    PreviewStep = 'previewStep',
}
